import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuItemOptionsQuerySchema } from '~/services/api/generated'

const schema = MenuItemOptionsQuerySchema.strict()

// ListMenuItemsRequest
export const MenuItemOptions = (_context: NoContext): z.ZodType<z.output<typeof schema>> => schema
